module.exports = __webpack_public_path__ + "static/img/groundabout8.3361b558.jpg";